// import img1 from "../../assets/sector/oil.jpg";
// import img2 from "../../assets/sector/electricity.jpg";
// import img3 from "../../assets/sector/defence.jpg";
// import img4 from "../../assets/sector/interior.jpg";
// import img5 from "../../assets/sector/transport.jpg";
import img6 from "../../assets/sector/health.jpg";

import {
  EconomicIcon,
  EnvirIcon,
  FacebookIcon,
  HumanIcon,
  InstaIcon,
  LinkedIcon,
  SnapIcon,
  TikTokIcon,
  TwitterIcon,
  VideoIcon,
  SocialIcon,
  OilIcon,
  WaterIcon,
  MinistrDefence,
  Interior,
  TransportIcon,
  PublicHealth,
} from "./Icons";

export const FooterValues = [
  {
    text: "SOLUTIONS",
  },
  {
    text: "SECTORS",
  },
  {
    text: "PARTNERS",
  },
  {
    text: "COMPANY",
  },
];

export const FooterIcon = [
  {
    img: <VideoIcon />,
    link: "https://www.youtube.com/",
  },
  {
    img: <FacebookIcon />,
    link: "https://www.facebook.com/",
  },
  {
    img: <LinkedIcon />,
    link: "https://www.linkedin.com/",
  },
  {
    img: <InstaIcon />,
    link: "https://www.instagram.com/",
  },
  {
    img: <SnapIcon />,
    link: "https://www.snapchat.com",
  },
  {
    img: <TikTokIcon />,
    link: "https://www.ticktok.com/",
  },
  {
    img: <TwitterIcon />,
    link: "https://twitter.com/",
  },
];
export const standardCardData = [
  {
    colClass_second: "col-lg-4 col-md-6 col-12",
    parentClass: "",
    videoUrl:
      "https://vz-e28eac45-f0a.b-cdn.net/7851d8aa-1dd9-49a6-9f75-269f98d8eb0f/playlist.m3u8",
    para1: "Impenetrable Security for Vital Infrastructure",
    para2: "Impenetrable Security for Vital Infrastructure",
    para3:
      "Cyboryx brings deep domain expertise and solutions to effectively tackle growing burden of today's industrial cybersecurity challenges.",
  },
  {
    colClass_second: "col-lg-4 col-md-6 col-12 mt-4 mt-sm-0",
    parentClass: "",

    videoUrl:
      "https://vz-e28eac45-f0a.b-cdn.net/582dc12d-7982-436b-8e70-fa4c9964816e/playlist.m3u8",
    para1: "State of the Art Sector Specific Security Operation Center",
    para2: "State of the Art Sector Specific Security Operation Center",
    para3:
      "Cyboryx's sector specific SOC brings hyper-vigilant 24/7 active monitoring Security Operation Center tailored for visibility and resiliency",
  },
  {
    colClass_second: "col-lg-4 col-sm-6 col-12 mt-4 mt-lg-0",
    parentClass: "",

    videoUrl:
      "https://vz-e28eac45-f0a.b-cdn.net/e679e6fc-fb3d-4944-8e37-f8986a61989d/playlist.m3u8",
    para1: "Ensures high standard ICS compliance",
    para2: "Ensures high standard ICS compliance",
    para3:
      "Cyboryx's vast international OT/IoT experience combined with the industry's best workforce ensures high industry compliance",
  },
];

export const SocialIconData = [
  {
    image: <HumanIcon />,
    text: "human development",
  },
  {
    image: <SocialIcon />,
    text: "Social development",
  },
  {
    image: <EconomicIcon />,
    text: "economic development",
  },
  {
    image: <EnvirIcon />,
    text: "environmental development",
  },
];

export const IndustrSector = [
  {
    img: <OilIcon />,
    text: "Oil and Gas",
    bg_image: "oil",
  },
  {
    img: <WaterIcon />,
    text: "Water and Electricity",
    bg_image: "electricity",
  },
  {
    img: <MinistrDefence />,
    text: "Ministry of Defense",
    bg_image: "defence",
  },

  {
    img: <Interior />,
    text: "Ministry of Interior",
    bg_image: "interrior",
  },
  {
    img: <TransportIcon />,
    text: "Ministry of Transport",
    bg_image: "transport",
  },
  {
    img: <PublicHealth />,
    text: "Ministry of Public Health",
    bg_image: "health",
  },
];
export const OurGoalsData = [
  {
    number: "01",
    para: "National Security",
    para2:
      "National Security Sustainable Footprint We aim to equip Qatar with the best ICS Cybersecurity solutions and protectits vital infrastructure against cyber attacks.",
  },
  {
    number: "02",
    para: "Sustainable Footprint",
    para2:
      "We aim to leave a sustainable footprint by developing our own Qatari ICS engineering workforce.",
  },
  {
    number: "03",
    para: "Education and expertise",
    para2:
      "We'll be partnering up with top international educational institutions specialized in OT automation and ICS Security.",
  },
  {
    number: "04",
    para: "QATAR NATIONAL VISION 2030",
    para2:
      "Qatar Vision 2030 Our strength lies in our adaptability towards the national vision. We'll continuously align ourselves with Qatar Vision 2030.",
  },
];

export const HeaderData = [
  {
    text: " Solutions",
    link: "/#solutions",
  },
  {
    text: "Sectors",
    link: "/#sectors",
  },
  {
    text: "Contact",
    link: "/contact",
  },
  {
    text: "Company",
    link: "/#company",
  },
];
